export enum NotificationTargetType {
  PUSH = 'push',
  SMS = 'sms',
  EMAIL = 'email',
}
